<div fxLayout="row" class="mt-2 mb-2">
    <div [formGroup]="formGroup" fxFlex fxLayout="row" fxLayoutGap="5px">
        <mat-form-field #fileNameControl fxFlex>
            <mat-label>{{'fileName' | translate}}</mat-label>
            <input #fileName formControlName="fileName" matInput (input)="resetFileNameValidation($event)">
            <mat-error fileName.invalid>{{getError('fileName')}}</mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="isSchedule" fxFlex="40">
            <mat-label>{{'suffixType' | translate}}</mat-label>
            <mat-select formControlName="suffixType">
                <mat-option *ngFor="let type of suffixTypes" [value]="type">{{type | lowercase | snakeCaseToCamelCase | translate}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <button *ngIf="!edit else cancelTmp" class="my-auto" color="sims" mat-icon-button (click)="enable()" [disabled]="edit" [matTooltip]="'addYourOwnFileName' | translate">
        <mat-icon svgIcon="edit"></mat-icon>
    </button>
    <ng-template #cancelTmp>
        <button class="my-auto" mat-icon-button color="sims" (click)="cancel()" matTooltip="{{'cancel' | translate}}" [disabled]="!edit">
            <mat-icon svgIcon="close"></mat-icon>
        </button>
    </ng-template>
    <button class="my-auto" mat-icon-button color="sims" (click)="confirm()" [disabled]="!formGroup.valid || !edit" matTooltip="{{'confirm' | translate}}">
        <mat-icon svgIcon="done"></mat-icon>
    </button>
</div>